
// When the user scrolls the page, execute myFunction
window.onscroll = function() {myFunction()};

function myFunction() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  if(document.getElementById("myBar")){
  	 document.getElementById("myBar").style.width = scrolled + "%";
  }
 
}

window.addEventListener('load', (event) => {
	var wrapGalleryEl = document.getElementById('insert-gallery-image');
	var galleryEl = document.getElementById('cf-image-gallery');
	if (wrapGalleryEl && galleryEl) {
		var fragmentGallery = document.createDocumentFragment();
		fragmentGallery.appendChild(galleryEl);
		wrapGalleryEl.appendChild(fragmentGallery);
	}
	var wrapProductEl = document.getElementById('insert-product-grid');
	var productGridEl = document.getElementById('cf-product-grid');
	if (wrapProductEl && productGridEl) {
		var fragmentProductGrid = document.createDocumentFragment();
		fragmentProductGrid.appendChild(productGridEl);
		wrapProductEl.appendChild(fragmentProductGrid);
	}
});
// if (document.querySelector("#blog-filter")) {
//     document.querySelector("#blog-filter").addEventListener("change", () => {
//         if (document.querySelector("#blog-filter").value != "") {
//             window.location.href = document.querySelector("#blog-filter").value;
//         }
//     });
// }
var btnFilter = document.querySelector("#blog-filter");
if(btnFilter){
	btnFilter.addEventListener('click', function() {
	if(btnFilter.classList.contains("open")){
		btnFilter.classList.remove("open");
	} else{
		btnFilter.classList.add("open");	
	}	

});

}
